import type { Chain } from '../../../../chain';
import type {
  NetworkProviderBuilder,
  NetworkProviderBuilderRegistry,
} from '../networkProviderBuilderRegistry.types';

export const createNetworkProviderBuilderRegistry =
  (): NetworkProviderBuilderRegistry => {
    const registry = new Map<Chain, NetworkProviderBuilder>();

    return {
      get: () => registry,
      register: (networkProviderBuilder) => {
        registry.set(networkProviderBuilder.chain, networkProviderBuilder);
      },
    };
  };
